import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { effect, inject, Injectable, signal } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop'
import { FormatPipe } from '@app/pipes/format.pipe';
import { defer, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SchedulerStepService } from '../step/scheduler-step.service';
import { CategoriesService } from '../categories/categories.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class Services {

  private apiURL: string = environment.apiURL
  private serviceEndPoint: string = environment.serviceEndPoint
  private http = inject(HttpClient)
  private schedulerService = inject(SchedulerStepService)
  private categoriesService = inject(CategoriesService)
  private router = inject(Router)
  private formatPipe = inject(FormatPipe)

  branchID = signal<string>('')

  servicesRessource = rxResource({ 
    request: () => ({
      branchID: this.branchID()
    }),
    loader: ({ request }) =>
      defer(() => {
        if (!request.branchID.trim()) return of(null);

        return this.http.get<ServiceResponse>(
          `${this.apiURL + this.formatPipe.transform(this.serviceEndPoint, {
            branchID: request.branchID
          })}`
        );
      })
  });

  eff = effect( () => {
    if (!this.servicesRessource.isLoading()){
      const branchServices = this.servicesRessource.value() as ServiceResponse
      if (branchServices){
        this.categoriesService.services.set(branchServices)
        this.schedulerService.branchSelected.set(branchServices.branch)
      }
    }
    
    if (this.servicesRessource.error()) {
      if((this.servicesRessource.error() as HttpErrorResponse).error === "Could not find any branches."){
        this.router.navigate([`/information/`, 'wrongBranch'], {queryParamsHandling: 'merge'})
      } else {  
        this.router.navigate([`/information/`, 'server'])
      }
    }
  })


}
